import { Airplay, Search, XSquare } from "react-feather";
import React, { useEffect, useRef, useState } from "react";
import SideDrawer from "../../components/input/SideDrawer";
import Button from "../../components/input/Button";
import UIMessage from "../../components/UIMessage";
import { useDispatch, useSelector } from "react-redux";
import ExchangeRateForm from "../../components/finance/exchangeRate/ExchangeRateForm";
import { getBulkDropdownData } from "../../api/keyvalue";
import LoadingSpinner from "../../components/LoadingSpinner";
import Grid from "../../components/Grid";
import {
  ActiveCellStyle,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import {
  addExchangeRate,
  exchangeRteById,
  searchExchangeRates,
  updateExchangeRate,
} from "../../api/finance/exchangeRateApi";
import { toast } from "react-toastify";
import { currencyContains } from "../../api/currencyApi";
import SearchDropdown from "../../components/input/SearchDropdown";
import Input from "../../components/input/Input";
import Dropdown from "../../components/input/Dropdown";
import { errorActions } from "../../store/error-slice";
import { exchangeHeaderValidations } from "../../components/validations/ExchangeRateCreation";
import { FORMS, MODULES } from "../../const";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";

const ExchangeRate = () => {
  const dispatch = useDispatch();

  const errorState = useSelector((state) => state.error.exchangeHeaderErrors);
  const user = useSelector((state) => state.user);
  const [editExchangeHeader, setEditExchangeHeader] = useState({});

  const { firstViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Finance,
    section: FORMS.EXCHANGE_RATE,
  });

  // drawer tabs
  const [drawerTab, setDrawerTab] = useState(firstViableTab);
  const [tab, setTab] = useState(1);

  //flags
  const [searchClicked, setSearchClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchRes, setSearchRes] = useState(false);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [reloadDates, setReloadDates] = useState(true);

  //dropdowns
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  //tab ref
  const excRateRef = useRef();
  const exhHeaderRef = useRef();

  //search ref
  const codeRef = useRef(null);
  const baseCurrencyRef = useRef(null);
  const currencyRef = useRef(null);
  const rateRef = useRef(null);
  const buyingRef = useRef(null);
  const sellingRef = useRef(null);
  const statusRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  //search states
  const [baseCurrency, setBaseCurrency] = useState("");
  const [currency, setCurrency] = useState("");
  const [status, setStatus] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      console.log(formattedToday, formattedWeekAgo);
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const handleDrawerOpen = () => {
    setEditMode(false);
    setDrawerTab(firstViableTab);
    setEditExchangeHeader(null);
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);
    dispatch(errorActions.clearExcHeaderError());

    const exhErrors = exchangeHeaderValidations(
      exhHeaderRef.current.getHeaderData()
    );
    if (Object.keys(exhErrors).length > 0) {
      dispatch(
        errorActions.validateExchangeHeader({
          exchangeHeaderData: exhHeaderRef.current.getHeaderData(),
        })
      );
      setIsSubmitLoading(false);
      toast.error("There was an error adding Exchange Rate", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    } else {
      if (editMode) {
        const exchangeRates = exhHeaderRef.current.getData();
        const newExchangeRates = exchangeRates.created;
        const modifiedExchangeRates = exchangeRates.modified;
        const unmodifiedExchangeRates = exchangeRates.unmodified;

        if (
          newExchangeRates.length +
            modifiedExchangeRates.length +
            unmodifiedExchangeRates.length <=
          0
        ) {
          dispatch(
            errorActions.validateExchangeHeader({
              exchangeHeaderData: exhHeaderRef.current.getHeaderData(),
            })
          );
          toast.error("Should have at least one exchange Rate Record", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        } else {
          delete exchangeRates.unmodified;
        }

        try {
          const response = await updateExchangeRate({
            exchangeHeader: exhHeaderRef.current.getHeaderData(),
            exchangeRates: exchangeRates,
            author: user.username,
          });
          if (response !== null) {
            toast.success("Exchange Rate Updated successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            // reset();
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        try {
          if (
            exhHeaderRef.current.getHeaderData().exhExchangeRates.length <= 0
          ) {
            toast.error("There should be at least one currency", {
              autoClose: 5000,
              containerId: "Main",
            });
            setIsSubmitLoading(false);
            return;
          }
          const response = await addExchangeRate({
            exchangeHeader: exhHeaderRef.current.getHeaderData(),
            // exhExchangeRates: exhHeaderRef.current.getRateData(),
            author: user.username,
          });
          if (response !== null) {
            toast.success("Exchange Rate added successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            reset();
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
    // reset();
    setIsSubmitLoading(false);
  };
  const reset = () => {
    exhHeaderRef.current.resetForm();
    setEditMode(false);
    setEditExchangeHeader(null);
  };
  useEffect(() => {
    (async () => {
      const { status: statusData, active: activeData } =
        await getBulkDropdownData([{ key: "status" }, { key: "active" }]);
      setActiveOptions(activeData);
      setStatusOptions(statusData);
    })();
  }, []);

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (tab === 1) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
      setSearchSubmitLoading(true);
    }
    const response = await searchExchangeRates({
      code: codeRef.current.value,
      baseCurrency: baseCurrency,
      currency: currency,
      rate: rateRef.current.value,
      buying: buyingRef.current.value,
      selling: sellingRef.current.value,
      status: status,
      from: fromDate,
      to: toDate,
    });
    setSearchRes(response);
    setSearchSubmitLoading(false);
  };
  const handleSearchReset = (e) => {
    e.preventDefault();
    codeRef.current.reset();
    setBaseCurrency("");
    setCurrency("");
    rateRef.current.reset();
    buyingRef.current.reset();
    sellingRef.current.reset();
    setStatus(null);
    // fromDateRef.current.reset();
    // toDateRef.current.reset();
    setSearchFieldReset(true);
    setReloadDates(true);
  };

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Airplay size={15} style={{ marginRight: "5px" }} />
            </span>
            Exchange Rate Search
          </div>
        </div>
        <Button
          template="drawerOpen"
          onClick={handleDrawerOpen}
          disabled={firstViableTab === -1}
          authenticated={true}
          form={FORMS.EXCHANGE_RATE.EXC.form}
          module={MODULES.Finance}
          editMode={false}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header"></h4>
                <div className="five fields">
                  <Input
                    label="Exchange Rate Code"
                    placeholder="Exchange Rate Code"
                    name="exchangeCode"
                    ref={codeRef}
                  />

                  <SearchDropdown
                    key={1}
                    placeholder={"base currency"}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setBaseCurrency(data)}
                    api={currencyContains}
                    fieldInfo={{
                      tableName: "masterdata.tms_vm_reg_currency",
                      primaryKey: "cur_id",
                      fieldName: "cur_currency",
                    }}
                    label="Base Currency"
                    // error={currentErrors.exhBaseCurrency}
                    // resetError={() =>
                    //     setCurrentErrors((prevState) => {
                    //         const {exhBaseCurrency: _, ...rest} = prevState;
                    //         return rest;
                    //     })
                    // }
                  />

                  <SearchDropdown
                    key={1}
                    placeholder={"currency"}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => {
                      setCurrency(data);
                    }}
                    api={currencyContains}
                    fieldInfo={{
                      tableName: "masterdata.tms_vm_reg_currency",
                      primaryKey: "cur_id",
                      fieldName: "cur_currency",
                      // id: exchangeRateData.excCurrency,
                    }}
                    label="Currency"
                    // error={currentErrors.excCurrency}
                    // resetError={() =>
                    //     setCurrentErrors((prevState) => {
                    //         const {excCurrency: _, ...rest} = prevState;
                    //         return rest;
                    //     })
                    // }
                  />
                  <Input
                    label="Rate"
                    placeholder="Rate"
                    name="exchangeRate"
                    ref={rateRef}
                  />
                  <Dropdown
                    label="Status"
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                </div>
                <div className="four fields">
                  <Input
                    label="Buying"
                    placeholder="Buying"
                    name="exchangeBuying"
                    ref={buyingRef}
                  />
                  <Input
                    label="Selling"
                    placeholder="Selling"
                    name="exchangeSelling"
                    ref={sellingRef}
                  />
                  <Input
                    label="From Date"
                    type="date"
                    name="exchangeFromDate"
                    placeholder="To Date"
                    max={toDate ?? new Date().toISOString().split("T")[0]}
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                    required={true}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="exchangeToDate"
                    placeholder="To Date"
                    min={fromDate}
                    max={new Date().toISOString().split("T")[0]}
                    value={toDate}
                    disabled={!fromDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                    required={true}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "id",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "exCode",
                  },
                  {
                    headerName: "Base Currency",
                    field: "bcurrency",
                  },
                  {
                    headerName: "Bank",
                    field: "bank",
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await exchangeRteById(props.data.id);
                  console.log("-------");
                  console.log(response);
                  setEditExchangeHeader(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <div
              className="blacklist-code-header"
              style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
            >
              <h3>
                Exchange Rate Code:{" "}
                {editExchangeHeader?.exchangeHeader?.exhCode}
              </h3>
            </div>
          ) : null
        }
        body={
          <form className="drawer-content" onSubmit={handleSubmit}>
            <div className={"blacklist-card-container"}>
              <div style={{ width: "60vw", boxShadow: "none" }}>
                <div className="ui top attached tabular menu">
                  <div
                    className={`item ${drawerTab === 1 ? "active" : ""}`}
                    onClick={() => {
                      setDrawerTab(1);
                    }}
                  >
                    <span>
                      <XSquare
                        size={15}
                        style={{
                          marginRight: "5px",
                        }}
                      />
                    </span>
                    <label>Exchange Rate</label>
                  </div>
                </div>

                <div
                  className="ui bottom attached active tab segment"
                  style={{ display: drawerTab === 1 ? "block" : "none" }}
                >
                  <ExchangeRateForm
                    editMode={editMode}
                    errors={errorState.exchangeHeaderErrors}
                    dropdown={{
                      statusOptions,
                    }}
                    ref={exhHeaderRef}
                    isLoading={isLoading}
                    currentValues={
                      editMode ? editExchangeHeader.exchangeHeader : null
                    }
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {editMode ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                        form={FORMS.EXCHANGE_RATE.EXC.form}
                        module={MODULES.Finance}
                        authenticated={true}
                        editMode={editMode}
                      />
                    ) : drawerTab === 1 && !isLoading ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                        form={FORMS.EXCHANGE_RATE.EXC.form}
                        module={MODULES.Finance}
                        authenticated={true}
                        editMode={editMode}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {submitted && errorState.hasErrors && (
                  <UIMessage type="negative" width="100%" centered={false}>
                    <div className="content">
                      <div className="header">
                        There was some errors with your submission
                      </div>
                      {Object.keys(errorState.exchangeHeaderErrors).length >
                        0 && (
                        <p>
                          <div className="header">Employee</div>
                          <div className="content">
                            <ul>
                              {Object.entries(
                                errorState.exchangeHeaderErrors
                              ).map(([_, value]) => (
                                <li>{value}</li>
                              ))}
                            </ul>
                          </div>
                        </p>
                      )}
                    </div>
                  </UIMessage>
                )}
              </div>
            </div>
          </form>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
};
export default ExchangeRate;
